import React from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@src/components/base/Text'
import { Button } from '@src/components/base/Button'
import { Icon } from '@src/components/base/Icon'
import { RootStackParamList } from '@src/navigation/types'
import { useWeightLossExperience } from '../context'

export const BottomSection = () => {
  const {
    goToNextStep,
    stepConfig,
    insurancePolicyIsEligible,
    appointmentRecurrenceExists,
  } = useWeightLossExperience()
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>()

  const handleOnPress = () => {
    if (appointmentRecurrenceExists) {
      navigation.replace('Drawer', { screen: 'Dashboard' })
      return
    }

    if (insurancePolicyIsEligible) {
      goToNextStep()
      return
    }
    navigation.replace('Drawer', { screen: 'Dashboard' })
  }

  return (
    <>
      {stepConfig?.note && (
        <Text
          type="regular"
          style={[styles.note, { marginBottom: insurancePolicyIsEligible ? 24 : 140 }]}
        >
          {stepConfig.note}
        </Text>
      )}
      <View style={styles.bottomContainer}>
        <Button
          type={stepConfig?.showRightAccessory ? 'primary' : 'outline'}
          size="block"
          accessoryRight={stepConfig?.showRightAccessory && <Icon name="arrow-right" />}
          accessibilityLabel="Continue"
          onPress={handleOnPress}
        >
          {stepConfig?.buttonText}
        </Button>
      </View>
    </>
  )
}

const themedStyles = StyleService.create({
  note: {
    fontSize: 15,
    textAlign: 'center',
    maxWidth: 300,
    alignSelf: 'center',
  },
  bottomContainer: {
    width: '100%',
    alignItems: 'center',
  },
})
